/* NECCST nav · hamburger toggle + Shop dropdown (touch). Hover/focus handled in CSS. */
(function () {
  var nav = document.getElementById('neccst-nav');
  if (!nav) return;

  // Mobile hamburger
  var toggle = nav.querySelector('.nav-toggle');
  if (toggle) {
    toggle.addEventListener('click', function () {
      var open = nav.classList.toggle('nav-open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      toggle.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
    });
    // Close when a mobile link is tapped
    nav.querySelectorAll('.nav-mobile a').forEach(function (a) {
      a.addEventListener('click', function () {
        nav.classList.remove('nav-open');
        toggle.setAttribute('aria-expanded', 'false');
      });
    });
  }

  // Shop dropdown · click toggle for touch devices
  nav.querySelectorAll('.nav-item.has-menu').forEach(function (item) {
    var btn = item.querySelector('.nav-shop');
    if (!btn) return;
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      var isOpen = item.classList.toggle('open');
      btn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    });
  });

  // Close any open dropdown on outside click / Escape
  document.addEventListener('click', function (e) {
    if (!nav.contains(e.target)) {
      nav.querySelectorAll('.nav-item.open').forEach(function (i) { i.classList.remove('open'); });
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      nav.querySelectorAll('.nav-item.open').forEach(function (i) { i.classList.remove('open'); });
      if (nav.classList.contains('nav-open') && toggle) { nav.classList.remove('nav-open'); toggle.setAttribute('aria-expanded', 'false'); }
    }
  });
})();
